const ORIGINE_ID = 13;

const useOrigine = () => ORIGINE_ID;

export default useOrigine;
